<div
  class="l-dialog__contents-custom"
  id="dialog_{{ id }}"
  attr.aria-labelledby="dialog_aria_{{ id }}"
  aria-modal="true"
  [@slideContent]="animationState"
  (@slideContent.start)="onAnimationStart($event)"
  (@slideContent.done)="onAnimationDone($event)"
>
  <div class="p-dialog" #dialogInfoDiv>
    <p
      #dialogInfo
      tabindex="0"
      (keydown)="onHandleKeydown($event, 0)"
      class="p-dialog__text"
      [innerHTML]="
        message ? (message | paramsTranslate : messageParams || [] | popupIndicator | metaUrl | linkStyle) : ''
      "
    ></p>
    <div class="p-dialog-btn p-dialog-btn--2btn">
      <button
        id="dialog_cancel-button_{{ id }}"
        class="c-btn-tertiary c-btn-tertiary--s"
        (click)="handleCancelClick()"
        (keydown)="onHandleKeydown($event, 1)"
        #cancelBtn
      >
        <span class="c-btn-tertiary__text" [innerHTML]="closeBtnLabel | staticMsg"></span>
      </button>
      <button
        id="dialog_confirm-button_{{ id }}"
        class="c-btn-{{ classType }} c-btn-{{ classType }}--s"
        aswThrottleClick
        (throttleClick$)="handleConfirmClick()"
        (keydown)="onHandleKeydown($event, 2)"
        #confirmBtn
      >
        <span class="c-btn-{{ classType }}__text" [innerHTML]="confirmBtnLabel | staticMsg"></span>
      </button>
    </div>
  </div>
</div>
